import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { BehaviorSubject } from 'rxjs'
import { AuthService, RestServices } from '../../services'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { emailValidator, validateAllFormFields } from '../../../models'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['../promotion.component.css', './reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {

    en = {}
    showEN = true
    checkToken = false
    tokenValid = false
    isConfirmed = false
    str: any
    formGroup: FormGroup
    statusSubmit = false
    completeStatus: boolean
    token: string
    hasErrorServer: boolean

    checkMailMxObservable = new BehaviorSubject<string>(null)

    constructor(public router: Router, private auth: AuthService, private formBuider: FormBuilder, private checkFormat: RestServices, private route: ActivatedRoute) {
        this.validatorForm()
        this.checkMailMxObservable.pipe(debounceTime(300), distinctUntilChanged()).subscribe(email => {
            if (email) {
                this.checkFormat.http_post('form/checkMx', { host: email }).subscribe(
                    response => {
                        this.str = response['status']
                    },
                )
            }
        })

    }

    ngOnInit() {
        this.route.paramMap.subscribe(paramMap => {
            this.token = paramMap.get('token')

            this.checkFormat.http_post('account/check-reset-token', { token: this.token }).subscribe(
                (result: any) => {
                    this.checkToken = true
                    this.tokenValid = result.success > 0
                },
            )
        })

    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    validatorForm() {
        this.formGroup = this.formBuider.group({
            email: ['', [Validators.required, emailValidator()]],
            organization: ['', [Validators.required]],
            user: ['', [Validators.required]],
            password: ['', [Validators.required]],
            password_confirmation: ['', [Validators.required]],
        }, {
            validator: this.checkPasswords,
        })
    }

    // check format email server
    checkFormatEmail() {
        const format = this.formGroup.value.email.slice(this.formGroup.value.email.search('@') + 1)

        this.checkMailMxObservable.next(format)
    }

    // message valid
    isFieldValid(field: string) {
        if (this.statusSubmit === true) {
            return !this.formGroup.get(field).valid && this.formGroup.get(field).touched
        } else {
            return this.formGroup.get(field).dirty && (this.formGroup.get(field).status === 'INVALID')
        }
    }

    // message css
    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
        }
    }

    // submit
    onSubmit() {
        if (this.formGroup.valid) {
            // send request to server to validate exists
            const body = this.getRequestData()
            this.hasErrorServer = false
            this.checkFormat.http_post('account/reset-password-validate', body).subscribe(
                (result: any) => {
                    if (result.error) {
                        this.hasErrorServer = true
                    } else {
                        this.isConfirmed = true
                    }
                },
            )
        } else {
            validateAllFormFields(this.formGroup)
            this.statusSubmit = true
        }
    }

    // submit isConfirmed
    submitApply() {
        if (this.isConfirmed) {
            const body = this.getRequestData()
            this.checkFormat.http_post('account/reset-password', body).subscribe(
                (result: any) => {
                    this.completeStatus = result.success
                    if (!result.success) {
                        this.hasErrorServer = true
                    }
                },
            )
        }
    }

    getRequestData() {
        return {
            token: this.token,
            email: this.formGroup.value.email,
            organizationId: this.formGroup.value.organization,
            userId: this.formGroup.value.user,
            password: this.formGroup.value.password,
        }
    }

    // back form
    reset() {
        this.isConfirmed = false
        this.completeStatus = false
        this.hasErrorServer = false
    }

    checkPasswords(group: FormGroup) { // here we have the 'passwords' group
        let pass = group.get('password').value
        let confirmPass = group.get('password_confirmation').value

        return pass === confirmPass ? null : { passwordConfirmNotSame: true }
    }
}



// WEBPACK FOOTER //
// ./src/app/promotion/reset-password/reset-password.component.ts